import jsonapi from 'jsonapi-parse';
import { currentDomain } from 'frontend-resources/js/Helpers/Locales';

export default ($axios) =>
    ({ env }) => ({
        async list() {
            if (!env.citationGeneratorApiUrl) {
                return [];
            }

            env.citationGeneratorApiUrl = env.citationGeneratorApiUrl.replace(
                'scribbr.com',
                currentDomain()
            );

            try {
                let response = await $axios.$get(
                    `${env.citationGeneratorApiUrl}/external/folders`
                );
                return jsonapi.parse(response).folders.flatMap(folder => folder.lists);
            } catch (error) {
                return [];
            }
        },
    });
